import { createAction, props } from '@ngrx/store';

// Import Records
export const importRecord = createAction(
    '[Data] Import record bulk import',
    props<{ newData: any }>()
);
export const importRecordSuccess = createAction(
    '[Data] Import record bulk import success'
);
export const importRecordFailure = createAction(
    '[Data] Import record bulk import failure',
    props<{ error: string }>()
);

//Fetch Bulk Users
export const fetchBulkImportHistory = createAction(
    '[Data] fetch records bulk import history'
);
export const fetchBulkImportHistorySuccess = createAction(
    '[Data] fetch records bulk import history success', 
    props<{ bulkItems: any[], total: number }>()
);
export const fetchBulkImportHistoryFail = createAction(
    '[Data] fetch records bulk import history failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state bulk import',
);